import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthProvider';
import { CallProvider } from './context/CallProvider';
import { OnlineStatusProvider } from './context/OnlineStatusProvider';
import App from './App';
import './index.css';
import { registerServiceWorker } from './lib/pushNotifications';

// Service worker'ı kaydet (PWA + push bildirimleri için).
// Push aboneliği senkronizasyonu AuthProvider login/sayfa yenileme sonrası yapılır;
// burada token olmadan API çağrısı atmamak için sadece register ediyoruz.
registerServiceWorker().catch(() => {
  // Desteklenmeyen tarayıcılarda sessizce geç
});

const rawBase = import.meta.env.BASE_URL || '/';
const cleanedBase = rawBase.replace(/^\/|\/$/g, '');
const basename = cleanedBase ? `/${cleanedBase}` : undefined;
console.log('[main] BASE_URL', rawBase, 'basename', basename);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <AuthProvider>
        <OnlineStatusProvider>
          <CallProvider>
            <App />
          </CallProvider>
        </OnlineStatusProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
